import {useContext, useEffect, useState} from "react";
import Spinner from "../../Spinner";
import subCustomerContext from "../../../contexts/subCustomers/subCustomerContext";
import Error from "../../alerts/Error";

function RemoveSubCustomer ({subCustomer}) {
	const {loading, removeSubCustomer} = useContext(subCustomerContext);
	const [error, setError] = useState(null);

	useEffect(() => {
		return () => {
			const backdrops = document.getElementsByClassName("modal-backdrop fade show");
			for (let i = 0; i < backdrops.length; i++) {
				backdrops[i].remove();
			}
		}
	}, []);

	async function onSubmit(evt) {
		evt.preventDefault();
		setError(null);
		try {
			await removeSubCustomer(subCustomer.id);
		}
		catch (e) {
			console.error(e);
			setError(e.message);
		}
	}

	return (
		<>
			<button className={"btn btn-danger btn-sm"} data-bs-toggle={"modal"} data-bs-target={"#removeSubCustomerModal" + subCustomer.id}>Remove customer contact</button>
			<div className={"modal fade"} id={"removeSubCustomerModal" + subCustomer.id} tabIndex="-1" aria-labelledby={"removeSubCustomerModalLabel" + subCustomer.id} aria-hidden="true">
				<div className={"modal-dialog"}>
					<div className={"modal-content"}>
						<form onSubmit={onSubmit}>
							<div className={"modal-header"}>
								<h5 className={"modal-title"} id={"removeSubCustomerModalLabel" + subCustomer.id}>Remove customer contact</h5>
								<button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} />
							</div>
							<div className={"modal-body"}>
								{error && <Error message={error} /> }
								<span>Are you sure you want to remove {subCustomer.fullName}?</span>
							</div>
							<div className={"modal-footer justify-content-between"}>
								<button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
								<button type={"submit"} className={"btn btn-danger"} disabled={loading}>{loading ? <Spinner />: 'Remove sub-customer'}</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</>
	)
}

export default RemoveSubCustomer;
